<template>
    <div id="MaGooodsMultiUnitTable">
        <vxe-table border highlight-hover-row :data="tableData1" resizable sizi="mini">
            <vxe-table-column align="center"  width="100" fixed="left">
                <template v-slot="{ column , rowIndex }">{{rowIndex==0?"主单位":`辅助单位${rowIndex}` }}</template>
            </vxe-table-column>
            <vxe-table-column align="center" width="100" title="单位名称" show-overflow fixed="left">
                <template v-slot="{row,rowIndex,columnIndex}">
                    <el-select class="selcet_sty" v-model="row.Unit" placeholder="请选择" size="mini" @change="selcetChange($event,row,rowIndex)" >
                        <el-option :label="item.FullName" :value="item.BaseNo" v-for="(item,index) in UnitList" :key="index"></el-option>
                    </el-select>
                </template>
            </vxe-table-column>
            <vxe-table-column align="center" width="80" title="换算率" show-overflow>
                <template v-slot="{row,rowIndex,columnIndex}">
                    <!-- <el-input :ref="'aaaa'+(columnIndex+rowIndex*10)" v-model="row.Percent" size="mini" :disabled="rowIndex==0?true:false" @input="row.Percent=row.Percent.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter.native="enterkey($event,(columnIndex+rowIndex*10))"></el-input> -->
                    <input autocomplete="off" :id="'aaaa'+(columnIndex+rowIndex*10)" :ref="columnIndex+rowIndex*10" class="input_sty" type="text" v-model="row.Percent" :disabled="rowIndex==0?true:false"  @input="row.Percent=row.Percent.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter="enterkey($event,(columnIndex+rowIndex*10))">
                </template>
            </vxe-table-column>
            <vxe-table-column align="center" width="120" title="条码" show-overflow>
                <template v-slot="{row,rowIndex,columnIndex}">
                    <!-- <el-input :ref="'aaaa'+(columnIndex+rowIndex*10)" v-model="row.BarCode" size="mini"  @input="row.BarCode=row.BarCode.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter.native="enterkey($event,(columnIndex+rowIndex*10))"></el-input> -->
                    <input autocomplete="off" :id="columnIndex+rowIndex*10" :ref="columnIndex+rowIndex*10" class="input_sty" type="text" v-model="row.BarCode" @input="row.BarCode=row.BarCode.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter="enterkey($event,(columnIndex+rowIndex*10))">
                </template>
            </vxe-table-column>
            <vxe-table-column align="center" width="120" title="零售价" show-overflow>
                <template v-slot="{row,rowIndex,columnIndex}">
                    <!-- <el-input :ref="'aaaa'+(columnIndex+rowIndex*10)" v-model="row.SalePrice" size="mini"  @input="row.SalePrice=row.SalePrice.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter.native="enterkey($event,(columnIndex+rowIndex*10))"></el-input> -->
                    <input autocomplete="off" :id="columnIndex+rowIndex*10" :ref="columnIndex+rowIndex*10" class="input_sty" type="text" v-model="row.SalePrice" @input="row.SalePrice=row.SalePrice.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter="enterkey($event,(columnIndex+rowIndex*10))">
                </template>
            </vxe-table-column>
            <vxe-table-column align="center" width="120" title="最低售价" show-overflow>
                <template v-slot="{row,rowIndex,columnIndex}">
                    <!-- <el-input :ref="'aaaa'+(columnIndex+rowIndex*10)" v-model="row.LSalePrice" size="mini"  @input="row.LSalePrice=row.LSalePrice.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter.native="enterkey($event,(columnIndex+rowIndex*10))"></el-input> -->
                    <input autocomplete="off" :id="columnIndex+rowIndex*10" :ref="columnIndex+rowIndex*10" class="input_sty" type="text" v-model="row.LSalePrice" @input="row.LSalePrice=row.LSalePrice.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter="enterkey($event,(columnIndex+rowIndex*10))">
                </template>
            </vxe-table-column>
            <vxe-table-column align="center" width="120" title="批发价" show-overflow>
                <template v-slot="{row,rowIndex,columnIndex}">
                    <!-- <el-input :ref="'aaaa'+(columnIndex+rowIndex*10)" v-model="row.WholesalePrice" size="mini"  @input="row.WholesalePrice=row.WholesalePrice.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter.native="enterkey($event,(columnIndex+rowIndex*10))"></el-input> -->
                    <input autocomplete="off" :id="columnIndex+rowIndex*10" :ref="columnIndex+rowIndex*10" class="input_sty" type="text" v-model="row.WholesalePrice" @input="row.BarCode=row.BarCode.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter="enterkey($event,(columnIndex+rowIndex*10))">
                </template>
            </vxe-table-column>
            <vxe-table-column align="center" width="120" title="预设进价" show-overflow>
                <template v-slot="{row,rowIndex,columnIndex}">
                    <input autocomplete="off" :id="columnIndex+rowIndex*10" :ref="columnIndex+rowIndex*10" class="input_sty" type="text" v-model="row.BuyPrice" @input="row.BuyPrice=row.BuyPrice.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter="enterkey($event,(columnIndex+rowIndex*10))">
                </template>
            </vxe-table-column>
            <vxe-table-column align="center" width="120" title="预设售价1" show-overflow>
                <template v-slot="{row,rowIndex,columnIndex}">
                    <!-- <el-input :ref="'aaaa'+(columnIndex+rowIndex*10)" v-model="row.PriceOne" size="mini"  @input="row.PriceOne=row.PriceOne.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter.native="enterkey($event,(columnIndex+rowIndex*10))"></el-input> -->
                    <input autocomplete="off" :id="columnIndex+rowIndex*10" :ref="columnIndex+rowIndex*10" class="input_sty" type="text" v-model="row.PriceOne" @input="row.PriceOne=row.PriceOne.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter="enterkey($event,(columnIndex+rowIndex*10))">
                </template>
            </vxe-table-column>
            <vxe-table-column align="center" width="120" title="预设售价2" show-overflow>
                <template v-slot="{row,rowIndex,columnIndex}">
                    <!-- <el-input :ref="'aaaa'+(columnIndex+rowIndex*10)" v-model="row.Percent" size="mini"  @input="row.PriceThree=row.PriceThree.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter.native="enterkey($event,(columnIndex+rowIndex*10))"></el-input> -->
                    <input autocomplete="off" :id="columnIndex+rowIndex*10" :ref="columnIndex+rowIndex*10" class="input_sty" type="text" v-model="row.PriceTwo" @input="row.PriceTwo=row.PriceTwo.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter="enterkey($event,(columnIndex+rowIndex*10))">
                </template>
            </vxe-table-column>
            <vxe-table-column align="center" width="120" title="预设售价3" show-overflow>
                <template v-slot="{row,rowIndex,columnIndex}">
                    <!-- <el-input :ref="'aaaa'+(columnIndex+rowIndex*10)" v-model="row.PriceThree" size="mini"  @input="row.PriceThree=row.PriceThree.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter.native="enterkey($event,(columnIndex+rowIndex*10))"></el-input> -->
                    <input autocomplete="off" :id="columnIndex+rowIndex*10" :ref="columnIndex+rowIndex*10" class="input_sty" type="text" v-model="row.PriceThree" @input="row.PriceThree=row.PriceThree.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter="enterkey($event,(columnIndex+rowIndex*10))">
                </template>
            </vxe-table-column>
            <vxe-table-column align="center" width="120" title="预设售价4" show-overflow>
                <template v-slot="{row,rowIndex,columnIndex}">
                    <!-- <el-input :ref="'aaaa'+(columnIndex+rowIndex*10)" v-model="row.PriceFour" size="mini"  @input="row.PriceFour=row.PriceFour.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter.native="enterkey($event,(columnIndex+rowIndex*10))"></el-input> -->
                    <input autocomplete="off" :id="columnIndex+rowIndex*10" :ref="columnIndex+rowIndex*10" class="input_sty" type="text" v-model="row.PriceFour" @input="row.PriceFour=row.PriceFour.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g,'$1')" @keyup.enter="enterkey($event,(columnIndex+rowIndex*10))">
                </template>
            </vxe-table-column>

            <vxe-table-column align="center" width="120" title="默认单位" show-overflow fixed="right">
                <template v-slot="{row,rowIndex,columnIndex}">
                    <el-radio v-model="row.Choose" :label="1" @change="radioChange(rowIndex)">默认</el-radio>
                </template>
            </vxe-table-column>
        </vxe-table>
    </div>
</template>
<script>
// 工具库
import tool from "@/utils/tool";
export default {
    data() {
        return {
            tableData1:[],//表格数据
            UnitList:[],//多单位下拉框数据
        };
    },
    props: {
        tableData:[Array]
    },
    watch: {
        tableData:{
            handler(newValue, oldValue) {
                // console.log('数据更新',newValue)
                this.tableData1 = newValue;
            },
            deep: true,
            immediate:true
        }
    },
    methods: {
        // 初始化多单位下拉框数据
        initUnitList(){
            let jparams = {
                user_id: tool.getLocal("userid"),
                session_id: tool.getLocal("sessionid"),
                type: 0, //0商品单位 1商品颜色 2商品尺码 3商品厂家 4银行账户 5费用科目 6收入科目 7货位
                pagesize: 100, //每页显示数量
                pagenum: 1, //当前页码
            };
            this.request.post("/index/Settings/get_other", {jparams: JSON.stringify(jparams)})
                .then(res => {
                    this.UnitList = [{FullName:'无',BaseNo:0},...res.data];
            });
        },
        // 单位选择下拉框改变时触发
        selcetChange(event,row,rowIndex){
            // console.log(event,row,rowIndex)
        },
        // 默认单位改变时触发
        radioChange(rowIndex){
            this.tableData1.map((item,index)=>{
                if(index!=rowIndex){
                    item.Choose = 0;
                }
            })
        },
        // 按下回车键
        enterkey(ev,serialNumber){
            let lastRow = this.tableData1.length;
            if(serialNumber<=lastRow*10){
                var inputText = document.getElementById(this.$refs[serialNumber+1].id);
                inputText.focus();
            }
        }
    },
    mounted() {
        this.initUnitList();
    },
  
};
</script>
<style lang="less">
#MaGooodsMultiUnitTable{
    //滚动条的宽度
    ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    }
    //滚动条的滑块
    ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: #ccc;
    }
    :-webkit-scrollbar-track {/*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 10px;
        background: #EDEDED;
    }
}
</style>
<style lang="less" scoped>
.selcet_sty{
    height: 30px!important;
}
.input_sty{
    height: 30px;
    width: 100%;
    display: block;
    position: relative;
    -webkit-box-flex: 1;
    box-flex: 1;
    padding: 0 !important;
    background: #fff;
    display: block;
    box-sizing: border-box;
    padding: 0 0;
    border: 0; //可根据需要修改有无边框显示长度和宽带
    overflow: hidden;
    // outline: none;
    text-align: center;
}
.el-select {
  width: 100%;
  /deep/ .el-input--mini .el-input__inner {
    height: 31px;
    line-height: 31px;
    border: 0; //可根据需要修改有无边框显示长度和宽带
    border-radius: 0;
  }
}
/deep/ .vxe-table .vxe-cell {
  padding: 0 !important;
}
/deep/ .vxe-table .vxe-body--column.col--ellipsis,
.vxe-table.vxe-editable .vxe-body--column,
.vxe-table .vxe-footer--column.col--ellipsis,
.vxe-table .vxe-header--column.col--ellipsis {
  height: 31px;
}
/deep/ .vxe-table .vxe-body--column:not(.col--ellipsis), .vxe-table .vxe-footer--column:not(.col--ellipsis), .vxe-table .vxe-header--column:not(.col--ellipsis){
  padding: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Table/MaGooodsMultiUnitTable/MaGooodsMultiUnitTable.vue